import React from "react";
import {
  introLotSize,
  introPrices,
  listingStatusNotice,
  positiveCount,
} from "../../../helpers/introProperty";
import "./IntroPropertySummary.scss";

const dollars = (value) => `$${Math.round(Number(value)).toLocaleString("en-US")}`;

const withThousands = (value) => {
  const count = positiveCount(value);
  return count ? Number(count).toLocaleString("en-US") : "";
};

export const IntroPriceSummary = ({ details }) => {
  const notice = listingStatusNotice(details);
  const { price, introducedPrice } = introPrices(details);
  return (
    <>
      {price ? <h5>{dollars(price)}</h5> : null}
      {introducedPrice ? (
        <p className="intro-price-summary__note">
          List price. Introduced at&nbsp;{dollars(introducedPrice)}
        </p>
      ) : null}
      {notice ? <p className="intro-price-summary__status">{notice}</p> : null}
    </>
  );
};

const Fact = ({ label, value }) =>
  value ? (
    <li>
      <span className="musthave-label">{label}</span>
      <span className="musthave-value">{value}</span>
    </li>
  ) : null;

export const IntroPropertyFacts = ({ details, isLand = false, lotTypeText = "" }) => {
  if (isLand) {
    return (
      <ul>
        <Fact label="Acreage" value={introLotSize(details, { isLand: true })} />
        <Fact label="Lot Type" value={lotTypeText} />
      </ul>
    );
  }
  return (
    <ul>
      <Fact label="Beds" value={positiveCount(details?.Bedrooms)} />
      <Fact label="Baths" value={positiveCount(details?.Bathrooms)} />
      <Fact label="Sqft" value={withThousands(details?.Sqft)} />
      <Fact label="Lot size" value={introLotSize(details)} />
    </ul>
  );
};
